<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="error-template">
                    <h2>
                        500 internal error</h2>
                    <div class="error-details">
                        Sorry, an error has occurred !
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
  name: 'InternalError'
}
</script>

<style>
    .error-template {padding: 40px 15px;text-align: center;}
    .error-actions {margin-top:15px;margin-bottom:15px;}
    .error-actions .btn { margin-right:10px; }
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/pages/errors/500.vue